import { MultiVoucherUsageVoucherItem } from 'app/src/features/Shopping/Direct/MultiVoucherUsage/components/MultiVoucherUsageVoucherItem'
import type { MultiVoucherGroupedType, MultiVoucherSelectedType } from 'app/src/model'
import { euroFormatter } from 'app/src/shared/helpers'
import { useTranslation } from 'app/src/shared/hooks'
import { cloneDeep } from 'lodash'
import { useMemo } from 'react'

export function MultiVoucherUsageSelection(props: {
  groupedSelectedVouchers: MultiVoucherSelectedType[] | undefined
  availableVouchers: MultiVoucherGroupedType[] | undefined
  setGroupedSelectedVouchers: (value: MultiVoucherSelectedType[]) => void
  requestedRefund: number
}) {
  const { t } = useTranslation('shopping', { keyPrefix: 'Direct.MultiVoucher.Usage' })

  const total = useMemo(() => {
    let totalValue = 0

    props.groupedSelectedVouchers?.forEach((vouch) => {
      totalValue += vouch.selectedQuantity * vouch.value
    })
    return totalValue
  }, [props.groupedSelectedVouchers])

  return (
    <div className='mt-8'>
      {t('Funnel.Steps.VoucherSelection.yourVoucherDescription') && (
        <div dangerouslySetInnerHTML={{ __html: t('Funnel.Steps.VoucherSelection.yourVoucherDescription') }} />
      )}
      <div className='grid grid-cols-1 lg:grid-cols-2'>
        <div className='col-span-1 mt-3'>
          {props.groupedSelectedVouchers?.map((vouch) => (
            <div key={vouch.value} className='mt-2'>
              <MultiVoucherUsageVoucherItem
                onVoucherQuantityChange={(selectedQuantity: number) => {
                  const voucherListItemIndex = props.groupedSelectedVouchers?.findIndex((x) => x.value === vouch.value) ?? -1
                  if (
                    voucherListItemIndex == -1 ||
                    props.groupedSelectedVouchers?.find((x) => x.value === vouch.value)?.selectedQuantity === selectedQuantity
                  )
                    return
                  const newVoucherList: MultiVoucherSelectedType[] | undefined = cloneDeep(props.groupedSelectedVouchers) ?? []
                  newVoucherList[voucherListItemIndex].selectedQuantity = selectedQuantity
                  props.setGroupedSelectedVouchers(newVoucherList)
                }}
                voucher={{
                  ...vouch,
                  availableQuantity: props.availableVouchers?.find((x) => x.value === vouch.value)?.availableQuantity ?? 0,
                }}
              />
            </div>
          ))}
        </div>
        <div className='col-span-1 mt-5 pl-0 md:pl-4'>
          <div className='flex w-full flex-col space-y-6 px-4 py-6 md:p-6 xl:p-8 dark:bg-gray-800'>
            <div className='flex w-full flex-col items-center justify-center space-y-4 border-b border-gray-200 pb-4'>
              <div className='flex w-full justify-between'>
                <div
                  className='text-base leading-4 text-gray-800 dark:text-white'
                  dangerouslySetInnerHTML={{ __html: t('Funnel.Steps.VoucherSelection.amountToPayLabel') }}
                ></div>

                <p className='text-base leading-4 text-gray-800 dark:text-gray-300'>
                  {euroFormatter.format(props.requestedRefund)}
                </p>
              </div>
              <div className='flex w-full items-center justify-between'>
                <div
                  className='text-base leading-4 text-gray-800 dark:text-white'
                  dangerouslySetInnerHTML={{ __html: t('Funnel.Steps.VoucherSelection.voucherCounterOverviewTable') }}
                ></div>
                <div
                  className='text-base leading-4 text-gray-800 dark:text-gray-300'
                  style={{ color: total >= props.requestedRefund ? 'black' : 'red' }}
                >
                  -{euroFormatter.format(total)}
                </div>
              </div>
            </div>
            <div className='flex w-full items-center justify-between'>
              <div
                className='text-base leading-4 text-gray-800 dark:text-white'
                dangerouslySetInnerHTML={{ __html: t('Funnel.Steps.VoucherSelection.totalLabel') }}
              ></div>
              <div className='text-base font-bold leading-4 text-gray-800 dark:text-gray-300'>
                {euroFormatter.format(props.requestedRefund > total ? props.requestedRefund - total : 0)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
